import {
    snakeCase,
    text,
    timestamp,
    varchar,
    integer,
} from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { categoryStatusEnum } from './_common.table'

export const serviceProviderCategoriesTable = snakeCase.table(
    'service_provider_categories',
    {
        id: id('spc'),
        name: varchar({ length: 150 }).notNull().unique(),
        slug: varchar({ length: 150 }).notNull().unique(),
        description: text(),
        status: categoryStatusEnum().notNull().default('active'),
        sortOrder: integer().notNull().default(0),
        deletedAt: timestamp({ withTimezone: true }),
        ...timestamps,
    },
)
